import bench from '../../assets/museu/bench.png';
import { getBenchPosition } from '../../utils/Positions';
import benches from '../benches';
import { Coordinate } from '../../model';
import './benches.css';

interface BenchesProps {
  coord: Coordinate;
}

const Benches: React.FC<BenchesProps> = ({ coord }) => {
  return (
    <>
      {benches.map(b => {
        const posC = getBenchPosition(coord, b);

        return (
          <img
            key={b.key}
            alt={b.key}
            className={'bench' + (b.dir === 'right' ? ' rotate' : '')}
            src={bench}
            style={{
              top: `calc(50% + ${posC.top}px)`,
              left: `calc(50% - ${posC.left}px)`,
            }}
          />
        );
      })}
    </>
  );
}

export default Benches;
